import gql from "graphql-tag";

export const CHECK_PAYMENT_STRIPE = gql`
  query CheckPaymentStripe($changeStep: Boolean) {
    checkPaymentStripe(changeStep: $changeStep)
  }
`;
